var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimCompanyReviewIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8574 7.68958L36.2517 11.8428V35.6691H19.8574V7.68958Z",
    fill: "#256AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3389 16.8706H31.7709",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3389 22.9907H31.7709",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3389 29.1118H31.7709",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36523 8.75298L27.071 0.91333V35.6691H9.36523V8.75298Z",
    fill: "#256AF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 13.8104H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 19.9308H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 26.0513H21.934",
    stroke: "white",
    strokeWidth: 2.30769
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.95177,
    cy: 30.0001,
    r: 9.08654,
    fill: "#6CCC93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4681 31.7516C12.7933 30.4264 12.7933 28.2777 11.4681 26.9525C10.1429 25.6273 7.99428 25.6273 6.66906 26.9525C5.34384 28.2777 5.34384 30.4264 6.66906 31.7516C7.99428 33.0768 10.1429 33.0768 11.4681 31.7516ZM11.4681 31.7516L13.8248 34.1083",
    stroke: "white",
    strokeWidth: 2.30769,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimCompanyReviewIc);
export default __webpack_public_path__ + "static/media/claim-company-review-ic.49f79183b0fe14c1f50c4508c6eccfe6.svg";
export { ForwardRef as ReactComponent };